import graphviz from './lib/graphviz';
import sequence from './lib/sequence';
import flowchart from './lib/flowchart';
import mermaid from './lib/mermaid';

export const PARSER_MODE = [
  {
    id: 'graphviz',
    convert: graphviz,
    name: 'Graphviz',
    description: 'https://www.graphviz.org/',
    random: [
      'example1',
      'example2',
      'example3',
      'example4',
      'example5',
      'example6',
    ],
  },
  {
    id: 'sequence',
    convert: sequence,
    name: 'SequenceUML',
    description: 'https://bramp.github.io/js-sequence-diagrams/',
    random: ['example1', 'example2', 'example3', 'example4'],
  },
  {
    id: 'flowchart',
    convert: flowchart,
    name: 'FlowChart',
    description: 'http://flowchart.js.org/',
    random: ['example1', 'example2'],
  },
  {
    id: 'mermaid',
    convert: mermaid,
    name: 'Mermaid',
    description: 'https://mermaidjs.github.io/',
    random: ['example1', 'example2', 'example3'],
  },
];

function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

export const getRandomByMode = async id => {
  const randomList = PARSER_MODE.find(({ id: oid }) => oid === id).random;
  const randomIndex = getRandomInt(randomList.length);
  const { default: value } = await import(`./examples/${id}/${
    randomList[randomIndex]
  }`);
  return value;
};
